const ACCESS_TOKEN_KEY = 'accessToken';
const USER_DETAILS_KEY = 'userDetails';

export const getRefreshToken = (): string | null => {
    try {
        const raw = localStorage.getItem(USER_DETAILS_KEY);
        if (!raw) return null;
        const details = JSON.parse(raw) as Record<string, unknown>;
        return typeof details?.refreshToken === 'string' ? details.refreshToken : null;
    } catch {
        return null;
    }
};

export const saveTokensFromRefresh = (data: {
    accessToken: string;
    refreshToken?: string;
    expiresAt?: string;
}) => {
    try {
        const raw = localStorage.getItem(USER_DETAILS_KEY);
        const existing = raw ? (JSON.parse(raw) as Record<string, unknown>) : {};
        const updated = {
            ...existing,
            accessToken: data.accessToken,
            ...(data.refreshToken ? { refreshToken: data.refreshToken } : {}),
            ...(data.expiresAt ? { expireDate: data.expiresAt, expiresAt: data.expiresAt } : {}),
        };
        localStorage.setItem(USER_DETAILS_KEY, JSON.stringify(updated));
        localStorage.setItem(ACCESS_TOKEN_KEY, data.accessToken);
    } catch {
        // ignore storage errors
    }
};

export const getAccessToken = (): string | null => {
    try {
        return localStorage.getItem(ACCESS_TOKEN_KEY);
    } catch {
        return null;
    }
};

export const clearAuthSession = () => {
    try {
        localStorage.removeItem(ACCESS_TOKEN_KEY);
    } catch {
        // ignore storage errors
    }
    try {
        localStorage.removeItem(USER_DETAILS_KEY);
    } catch {
        // ignore storage errors
    }
};

const decodeJwtPayload = (token: string): Record<string, unknown> | null => {
    try {
        const payload = token.split('.')[1];
        if (!payload) return null;
        const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
        const json = atob(base64);
        return JSON.parse(json) as Record<string, unknown>;
    } catch {
        return null;
    }
};

export const isAccessTokenExpired = (token: string | null): boolean => {
    if (!token) return false;
    const payload = decodeJwtPayload(token);
    const exp = typeof payload?.exp === 'number' ? payload.exp : null;
    if (!exp) return false;
    return Date.now() >= exp * 1000;
};
